export default "__VITE_ASSET__CD$i6TIy__"